import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Support responder console — proxied through the dashboard server to tech,
// gated on Nano-Support-Access (full admins bypass). Polls so new engineer
// messages surface without a manual refresh.
export function useSupportThreads() {
  return useQuery({
    queryKey: ['supportThreads'],
    queryFn: async () => (await api.get('/api/support/threads')).data.threads,
    refetchInterval: 15 * 1000,
    refetchOnWindowFocus: true,
    staleTime: 0,
    retry: false,
  });
}

export function useSupportThread(id) {
  return useQuery({
    queryKey: ['supportThread', id],
    queryFn: async () => (await api.get(`/api/support/threads/${id}`)).data,
    enabled: Boolean(id),
    refetchInterval: id ? 12 * 1000 : false,
    staleTime: 0,
  });
}

export function useResponderUnread() {
  return useQuery({
    queryKey: ['supportResponderUnread'],
    queryFn: async () => (await api.get('/api/support/threads/unread-count')).data.unread,
    refetchInterval: 20 * 1000,
    refetchOnWindowFocus: true,
    retry: false,
  });
}

export function useReplySupport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, body }) => (await api.post(`/api/support/threads/${id}/reply`, { body })).data,
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: ['supportThread', id] });
      qc.invalidateQueries({ queryKey: ['supportThreads'] });
      qc.invalidateQueries({ queryKey: ['supportResponderUnread'] });
    },
  });
}

export function useResolveSupport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => (await api.post(`/api/support/threads/${id}/resolve`)).data,
    onSuccess: (_d, id) => {
      qc.invalidateQueries({ queryKey: ['supportThread', id] });
      qc.invalidateQueries({ queryKey: ['supportThreads'] });
    },
  });
}
